// Portal: Support Request. Sends an email to the XSite team (via the
// portal API) and logs the request in the CRM. Optional site selector
// is populated from the customer's own fleet.

import { useEffect, useState } from 'react';
import axios from 'axios';

export default function PortalSupport() {
  const [sites, setSites] = useState([]);
  const [siteId, setSiteId] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get('/api/portal/sites')
      .then((res) => { if (!cancelled) setSites((res.data || []).filter((s) => s.status === 'Active')); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await axios.post('/api/portal/support-request', {
        site_id: siteId ? Number(siteId) : undefined,
        subject,
        message
      });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  if (sent) {
    return (
      <section className="page">
        <div className="page-header"><h2>Support</h2></div>
        <div className="portal-sent">
          <p><strong>Request sent.</strong> Our team has been notified and will
          follow up at your account email — typically the same business day.</p>
          <button
            type="button"
            className="btn-secondary"
            onClick={() => { setSent(false); setSubject(''); setMessage(''); setSiteId(''); }}
          >
            Submit another request
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="page">
      <div className="page-header"><h2>Support</h2></div>
      <p className="portal-footnote" style={{ marginTop: 0 }}>
        Send us a message about any of your sites — configuration questions,
        data issues, or anything that doesn't look right. For urgent issues
        call us directly.
      </p>

      <form className="portal-form" onSubmit={handleSubmit}>
        <label>
          Site (optional)
          <select className="form-input" value={siteId} onChange={(e) => setSiteId(e.target.value)}>
            <option value="">— All / general —</option>
            {sites.map((s) => (
              <option key={s.id} value={s.id}>{s.site_name} ({s.site_number})</option>
            ))}
          </select>
        </label>
        <label>
          Subject
          <input
            className="form-input"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            maxLength={200}
            required
          />
        </label>
        <label>
          Message
          <textarea
            className="form-input"
            rows={7}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </label>
        {error && <p className="portal-error">{error}</p>}
        <button type="submit" className="btn-primary" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send request'}
        </button>
      </form>
    </section>
  );
}
